import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import GalleryGrid from 'src/js/components/gallery-grid';
import { PREVIEW_COLUMNS_COUNT } from 'src/js/constants/common';

const { Paragraph, Container } = designSystem;

const GalleryGridSection = ({
  templates,
  templatesLabel,
  isAISiteWizardEnabled,
  gridColumns,
  onTemplatePreviewClick,
  onTemplateEditClick,
  isLoading,
  galleryGridRef = null,
}) => (
  <div className="ws-gallery-grid-section">
    <Container className="ws-gallery-grid-section__label">
      <Paragraph appearance="low-emphasis">{templatesLabel}</Paragraph>
    </Container>

    <GalleryGrid
      isLoading={isLoading}
      isAISiteWizardEnabled={isAISiteWizardEnabled}
      ref={galleryGridRef}
      templates={templates}
      gridColumns={gridColumns}
      onTemplatePreviewClick={onTemplatePreviewClick}
      onTemplateEditClick={onTemplateEditClick}
    />
  </div>
);

GalleryGridSection.propTypes = {
  templatesLabel: PropTypes.string.isRequired,
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      previewUrl: PropTypes.string,
    })
  ).isRequired,
  galleryGridRef: PropTypes.shape({
    current: PropTypes.any,
  }),
  isLoading: PropTypes.bool.isRequired,
  gridColumns: PropTypes.oneOf(Object.values(PREVIEW_COLUMNS_COUNT)).isRequired,
  onTemplatePreviewClick: PropTypes.func.isRequired,
  onTemplateEditClick: PropTypes.func.isRequired,
  isAISiteWizardEnabled: PropTypes.bool.isRequired,
};

export default GalleryGridSection;
